export default __webpack_public_path__ + "static/media/mon_64.83ef1cca.png";